import { IValidation } from "./";

const Validation: IValidation = {
  error: "Por favor, digite uma URL válida",
  validate: (input: string) =>
    /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?::\d{2,5})?(?:\/[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/.test(
      input
    ),
};

export default Validation;
